import {
    Component,
    signal,
    WritableSignal,
    ElementRef,
    inject,
    OnDestroy,
    Input,
    viewChild,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import {
    EventInfo,
    IqEventBusTransformationService,
    IqEventBusBrokerHandler,
    CustomElementConsumerEventName,
    EventQuery,
    matchQuery,
    IqEventBusBrokerService,
} from '../state/services';
import { unescape } from 'lodash';
@Component({
    selector: 'iq-event-bus-label',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './iq-event-bus-label.component.html',
    styleUrl: './iq-event-bus-label.component.scss',
})
export class IqEventBusLabelComponent implements OnDestroy {
    data: WritableSignal<any> = signal({});
    private _elementRef: ElementRef = inject(ElementRef);
    private _transform: IqEventBusTransformationService = inject(
        IqEventBusTransformationService,
    );

    /**
     * The event name to listen for as it is updated
     */
    @Input({required: true})
    eventName: string;

    /**
     * Whether to get the immediate event that was last fired by the name
     */
    @Input()
    immediate: boolean = true;

    @Input()
    query: string = null;

    loaded: WritableSignal<boolean> = signal(false);
    template: WritableSignal<string> = signal('');

    templateWrapper = viewChild<ElementRef<HTMLDivElement>>('templateWrapper');
    renderedWrapper = viewChild<ElementRef<HTMLDivElement>>('renderedWrapper');
    private _controller: AbortController;

    private _eventBus: IqEventBusBrokerService = inject(IqEventBusBrokerService); 
    private _deregister: Record<string, IqEventBusBrokerHandler> = {};

    constructor() {
        this._controller = new AbortController();

        setTimeout(() => {
            if(!this.loaded) {
                this.render();
            }
        });
    }

    private render(payload: any = {}) {
        this.loaded.set(true);
        
        const templateWrapperElement = this.templateWrapper()?.nativeElement;
        if (!templateWrapperElement) return null;

        const template = unescape(templateWrapperElement.innerHTML.trim());

        const html = this._transform.render(template, {
            payload,
        });

        this.renderedWrapper().nativeElement.innerHTML = html;
    }

    ngOnDestroy() {
        this._controller.abort();
        this._eventBus.unregisterMap(this._deregister);
    }

    ngOnInit() {
        this._deregister = this._eventBus.registerMap({
            [this.eventName]: {
                callback: (payload: any) => {
                    this.render(payload);
                },
                opts: {
                    immediate: this.immediate,
                }
            }
        });
    }
}
